import { render, staticRenderFns } from "./HistorialTable.vue?vue&type=template&id=bf8014ce&scoped=true&"
import script from "./HistorialTable.vue?vue&type=script&lang=js&"
export * from "./HistorialTable.vue?vue&type=script&lang=js&"
import style0 from "./HistorialTable.vue?vue&type=style&index=0&id=bf8014ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8014ce",
  null
  
)

export default component.exports